import { render, staticRenderFns } from "./beneficiary-details.vue?vue&type=template&id=6e64e904"
import script from "./beneficiary-details.vue?vue&type=script&lang=ts"
export * from "./beneficiary-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports